<div class="animated fadeIn">
  <div class="row">
    <div class="col-sm-12 col-lg-12">
      <div class="card">
        <div class="card-header">
          <strong>Notifications</strong>&nbsp;&nbsp;
          <!-- <a [routerLink]="['/account/profile', {outlets: {'profile': ['preference-notification']}}]"
          (click)="closeSidebar()" class="btn btn-brand btn-sm btn-facebook ml-1"
          type="button">
          <i class="fa fa-cog"></i>
        </a> -->
      </div>
      <div class="card-body">
        @if (isLoading) {
          <div style="padding: 0px;">
            <div class="row">
              <div class="col-12">
                @for (number of [0,1,2,3,4,5,6]; track number) {
                  <div class="d-flex flex-column"
                    style="padding: 10px; border: 1px solid #d6dade; margin: 5px; background-color: white;">
                    <div class="d-flex flex-row">
                      <ngx-skeleton-loader
                      [theme]="{ width: '30px', height: '30px', 'margin-left': '10px', 'margin-right': '10px' }"></ngx-skeleton-loader>
                      <ngx-skeleton-loader count="1"
                        [theme]="{ 'border-radius': '0', width: '20vw', height: '3vh', 'margin-right': '20px' }">
                      </ngx-skeleton-loader>
                    </div>
                    <ngx-skeleton-loader count="1" [theme]="{ 'border-radius': '0', height: '3vh' }">
                    </ngx-skeleton-loader>
                  </div>
                }
              </div>
            </div>
          </div>
        }
        <!-- <nav class="navbar navbar-expand-lg navbar-light bg-light navbar-top-radius">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav mr-auto">
            <li class="nav-item">
              <button (click)="showFilter()" class="btn btn-brand btn-sm btn-facebook mr-1"
                type="button">
                <i class="fa fa-filter"></i>
                <span>Filter</span>
              </button>
            </li>
            <li class="nav-item">
              <button (click)="showAction()" class="btn btn-brand btn-sm btn-facebook mr-1"
                type="button">
                <i class="fa fa-cloud-upload"></i>
                <span>Action</span>
              </button>
            </li>
          </ul>
        </div>
      </nav> -->
      @if (!isLoading) {
        @for (notification of notifications; track notification) {
          <div
            class="alert fade show g-brd-around g-brd-gray-light-v4 g-pa-20" role="alert">
            <div class="media">
              <div class="d-flex g-mr-10">
                @if (notification.notificationType == 'CALL_LATER') {
                  <div class="p-2 bd-highlight"><i class="avatar-square-small bi bi-telephone-fill"></i></div>
                }
                @if (notification.notificationType == 'CALL_LATER') {
                  <div class="p-2 bd-highlight"><i class="avatar-square-small bi bi-telephone-fill"></i></div>
                }
                @if (notification.notificationType == 'TASK_REMINDER') {
                  <div class="p-2 bd-highlight"><i class="avatar-square-small bi bi-alarm"></i></div>
                }
                @if (notification.notificationType == 'TASK_ASSIGNMENT') {
                  <div class="p-2 bd-highlight"><i class="avatar-square-small bi bi-list-task"></i></div>
                }
                @if (notification.notificationType == 'LEAD_ASSIGNMENT') {
                  <div class="p-2 bd-highlight"><i class="avatar-square-small bi bi-person-check-fill"></i></div>
                }
                @if (notification.notificationType == 'DOCUMENT_OPEN') {
                  <div class="p-2 bd-highlight"><i class="avatar-square-small bi bi-envelope-open"></i></div>
                }
                @if (notification.notificationType == 'DATA_EXPORT_DONE') {
                  <div class="p-2 bd-highlight"><i class="avatar-square-small bi bi-cloud-arrow-down-fill"></i></div>
                }
                @if (notification.notificationType == 'BULK_UPLOAD_COMPLETED') {
                  <div class="p-2 bd-highlight"><i class="avatar-square-small bi bi-file-earmark-excel-fill"></i></div>
                }
                @if (notification.notificationType == 'NEW_MEMBER_JOINED') {
                  <div class="p-2 bd-highlight"><i class="avatar-square-small bi bi-person-plus-fill"></i></div>
                }
                @if (notification.notificationType == 'BATCH_ACTION') {
                  <div class="p-2 bd-highlight"><i class="avatar-square-small bi bi-gear-wide-connected"></i></div>
                }
                @if (notification.notificationType == 'PAYMENT_EVENT') {
                  <div class="p-2 bd-highlight"><i class="avatar-square-small bi bi-currency-dollar"></i></div>
                }
              </div>
              <div class="media-body">
                <div class="d-flex justify-content-between">
                  <p class="m-0"><strong>{{notification.notificationType | formatUnderscore}}</strong>
                </p>
                <span class="align-self-center small text-nowrap">{{notification.scheduledAt | formatDate }}</span>
              </div>
              <p class="m-0">{{notification.content}}</p>
            </div>
          </div>
        </div>
      }
      @if (nextToken !== undefined && nextToken !== null) {
        <button mat-button color="primary" (click)='loadMore()' style="width: 100%;">Load More</button>
      }
    }
  </div>
</div>
</div>
</div>
</div>